





























import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Location } from "vue-router";
import { ROUTE_NAMES } from "../../router/routenames";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

import { api as deskApi } from "../../store/modules/desk";
import { api as userApi } from "../../store/modules/user";
import { SignupUserPayload } from "../../store/modules/user/types";
import { WaitingPlayer } from "../../store/modules/desk/types";
import ItemRefList from "../controls/ItemRefList.vue";

@Component({ components: { DoKoHtmlDialog, DoKoBtn, ItemRefList } })
export default class DoKoLogin extends Vue {
  loading = false;
  error = "";

  @Getter(deskApi.getters.getPlayerWaitingList, {
    namespace: deskApi.namespace,
  })
  playerWaitingList!: WaitingPlayer[];
  @Getter(userApi.getters.getAvatarId, { namespace: userApi.namespace })
  avatarId!: string;
}
